import { Flex } from '../../../layout/flex';
import { Icon, IconName } from '../../../medias';
import { ToastProps } from '../toast.types';

export function ToastCloseButton({
  closable = true,
  onClose
}: {
  closable?: boolean;
  onClose: ToastProps['onClose'];
}): JSX.Element | null {
  if (!closable) {
    return null;
  }
  return (
    <Flex
      data-testid={`toast-close-button`}
      as="button"
      backgroundColor="transparent"
      onClick={onClose}
      w="22px"
      h="22px"
      alignItems="center"
      justifyContent="center"
      padding={0}
      border="none"
      cursor="pointer"
      _hover={{ svg: { stroke: '#000000' } }}
    >
      <Icon name={IconName.Close} />
    </Flex>
  );
}
